import * as React from 'react';
import { Heading, InfoIcon } from 'wix-style-react';
import { translate, InjectedTranslateProps } from 'react-i18next';
import { DataHooks } from '@src/constants/data-hooks';

import * as css from '../categories.scss';

interface Props extends InjectedTranslateProps {
  title: string;
  tooltip: string;
}

export const CategoryHeadline = translate()(({ t, title, tooltip }: Props) => (
  <>
    <span className={css.headline}>
      <Heading dataHook={DataHooks.AdvancedEditorsTabHeadline} appearance="H3">
        {t(title)}
      </Heading>
    </span>
    <span className={css.infoIcon}>
      <InfoIcon content={t(tooltip)} />
    </span>
  </>
));
